module.exports = __webpack_public_path__ + "static/media/brain.4150a298.svg";